export enum TwoFactorStep {
  DOWNLOAD = 'download',
  SCAN_QR = 'scan-qr',
  VERIFY_CODE = 'verify-code',
  SUCCESS = 'success',
}

export enum PasswordAttempts {
  MAX_ATTEMPTS = 3,
  WARNING_THRESHOLD = 2,
}

export enum TwoFactorStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}
